import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import $ from "jquery";
import Server from '../../functions/server';

export default class DropDown extends React.Component {

  state = {
    row: [],
    types: []
  }

  remove(id) {
    let context = this;
    let view_executive = this.props.row.view_executive;
    let menu = this.props.row.menu;
    let type = id;
    let executive = this.props.row.executive;
    context.setState({
      load: false,
      message: 'Remove menu controller!!!',
      opendialog: false
    });
    let temp = [];
    let data1 = {'type': type, 'menu': menu, 'view_executive': view_executive, 'executive': executive };
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'menucontrol/removecontrolmenu.php',
      success: function(data)
      {
        console.log(data);
        context.setState({
          load: false,
          opendialog: false
        });
        context.removeFromState(id);
      },
      error: function(err)
      {
        console.log(err);
        context.setState({
          load: false,
        });
        alert('Try again!!!!')
      }
    })
  }

  removeFromState(id) {
    let x = [];
    this.state.row.map((temp) => {
      if (temp.type != id) {
        x.push(temp);
      }
    });
    this.setState({
      row: x
    });
  }

  componentDidMount() {
    let row = this.props.row.type_name;
    let context = this;
    this.setState({ row }, () => {
      context.getCustomerTypesValue();
    });
  }

  getCustomerTypes() {
    var x = [];
    try {
      this.state.row.map((y) => {
        x.push({key: y.type_name, text: y.type_name, value: y.type});
      });
    } catch (e) {}
    return x;
  }

  getCustomerTypesValue() {
    var x = [];
    try {
      this.state.row.map((y) => {
        x.push(y.type);
      });
    } catch(e) {}
    this.setState({
      types: x
    });
  }

  onChange = (e, {value}) => {
    if (!this.props.menuPermission.edit) {
      alert("Access is Denied!!!");
      return;
    }
    let oldValue = this.state.types;
    let length = value.length;
    if (length < oldValue.length) {
      let array1 = oldValue.filter(val => !value.includes(val));
      this.remove(array1[0]);
    }
    this.setState({ types: value })
  }

  render() {
    let { types } = this.state;
    return (
      <Dropdown fluid multiple
        id="technology" onChange={this.onChange}
        search selection options={this.getCustomerTypes()}
        value={types}
        fluid style={{ borderColor: '#5A9CBB', fontSize: 11 }} />
    );
  }

}
